export default {
  addFileNamesAboveEachImage: 'Додати імена файлів над кожним зображенням',
  comments: 'Коментарі',
  couldNotLoadWhiteboard: 'Не вдалося завантажити дошку. Спробуйте ще раз.',
  filterComments: 'Фільтр коментарів',
  goToWhiteboardAfterSending: 'Перейти на дошку після відправки',
  inProgress: 'В роботі',
  limits: 'Ліміти',
  markAsUnresolved: 'Позначити як невирішене',
  pagesOnThisWhiteboard: 'Сторінки на цій дошці',
  resolved: 'Вирішені',
  saveDraft: 'Зберегти чернетку',
  setInProgress: 'Перевести в роботу',
  shapesOnThisPage: 'Фігури на цій сторінці',
  showInProgressComments: 'Показувати в роботі',
  showResolvedComments: 'Показувати вирішені',
  unsetInProgress: 'Прибрати з роботи',
  whiteboardRoomFull:
    'Досягнуто ліміту підключень до цієї дошки. Закрийте зайві вкладки з цією дошкою та спробуйте ще раз.',
  youHaveUsedAllPagesQuota: 'Ви використали всі доступні сторінки.',
  youHaveUsedAllShapesQuota: 'Ви використали всі фігури на цій сторінці.'
};
